import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "utils/asyncComponent";

const routes = [
  {
    path: "file-management",
    component: asyncComponent(() => import("./FileManagement")),
  },
  {
    path: "espn",
    component: asyncComponent(() => import("./Espn"), {
      skipPlaceholder: true,
    }),
  },

  { path: "clients", component: asyncComponent(() => import("./Clients")) },
  { path: "programs", component: asyncComponent(() => import("./Programs")) },
  {
    path: "commodities",
    component: asyncComponent(() => import("./Commodities")),
  },
  { path: "clinical", component: asyncComponent(() => import("./Clinical")) },
  {
    path: "administrations",
    component: asyncComponent(() => import("./Administrations")),
  },
  { path: "reports", component: asyncComponent(() => import("./Reports")) },
  {
    path: "dashboards",
    component: asyncComponent(() => import("./Dashboards")),
  },
  {
    path: "log",
    component: asyncComponent(() => import("./SormasPushLog")),
  },
  {
    path: "non-conformity",
    component: asyncComponent(() => import("./NonConformity")),
  },
  { path: "dispatch", component: asyncComponent(() => import("./Dispatch")) },
  { path: "billings", component: asyncComponent(() => import("./Billings")) },
  {
    path: "payment-history",
    component: asyncComponent(() => import("./Billings/PaymentHistory")),
  },
  {
    path: "payment-details",
    component: asyncComponent(() =>
      import("./Billings/PaymentHistory/PaymentDetails/PaymentDetails")
    ),
  },
  {
    path: "manage-report",
    component: asyncComponent(() => import("./Billings/ManageReport")),
  },
  {
    path: "add-billing",
    component: asyncComponent(() => import("./Billings/AddBilling")),
  },
  {
    path: "facility",
    component: asyncComponent(() => import("./Administrations/Facility")),
  },
  {
    path: "addfacility",
    component: asyncComponent(() =>
      import("./Administrations/Global/ManageFacility")
    ),
  },
  {
    path: "admin-user",
    component: asyncComponent(() =>
      import("./Administrations/Global/AdminUsers")
    ),
  },
  {
    path: "machine-setting",
    component: asyncComponent(() =>
      import("./Administrations/Facility/MachineSettings/CreateMachineSettings")
    ),
  },
  {
    path: "profile",
    component: asyncComponent(() => import("./Clients/Profile")),
  },
  {
    path: "user-profile/:name",
    component: asyncComponent(() => import("./Profile")),
  },
  {
    path: "manage-result",
    component: asyncComponent(() => import("./ManageResult")),
  },
];

const App = ({ match }) => {
  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={`${match?.url}${route.path}`}
            component={(props) => <route.component {...props} />}
          />
        ))}
      </Switch>
    </div>
  );
};

App.propTypes = {
  match: PropTypes.object,
};

export default App;
